module.exports = __webpack_public_path__ + "media/images/logo/70x70-68c38e77bba547c24e9bd05d830f0f67.png";